/**
 * D18 — Help & Support.
 *
 * The six topics from the artwork. Their destinations were never designed
 * (gap G-21); each currently opens an article view driven by the same content
 * keys, and "Contact Support" hands off to the configured channel rather than
 * implying a live-chat capability the product does not yet have.
 */

import { Linking, StyleSheet, View } from 'react-native';

import { space } from '../../theme';
import { ListRow } from '../../components/common/ListRow';
import { ScreenShell } from '../../components/layout/ScreenShell';
import type { DonorScreenProps } from '../../app/navigation/types';
import { useT } from '../../core/i18n/LanguageProvider';

const TOPICS = [
  { key: 'how', icon: 'info', title: 'How Donations Work', subtitle: 'Learn how your donation helps' },
  { key: 'payment', icon: 'card', title: 'Payment Issues', subtitle: 'Facing problems with payment?' },
  {
    key: 'refunds',
    icon: 'donations',
    title: 'Cancellation & Refunds',
    subtitle: 'Our cancellation and refund policy',
  },
  {
    key: 'distribution',
    icon: 'distribute',
    title: 'Distribution Questions',
    subtitle: 'Have questions about distribution?',
  },
  { key: 'faq', icon: 'help', title: 'FAQ', subtitle: 'Frequently asked questions' },
] as const;

const SUPPORT_EMAIL = 'support@mealforall.example';

export function HelpScreen({ navigation }: DonorScreenProps<'Help'>) {
  const t = useT();
  return (
    <ScreenShell
      leading="menu"
      onMenuPress={() => navigation.getParent()?.dispatch({ type: 'OPEN_DRAWER' })}
      testID="screen-help"
      title={t('Help & Support')}
      subtitle={t("We're here to help you.")}
    >

      <View style={styles.list}>
        {TOPICS.map((topic) => (
          <ListRow
            key={topic.key}
            standalone
            icon={topic.icon}
            title={t(topic.title)}
            subtitle={t(topic.subtitle)}
            testID={`help-${topic.key}`}
            onPress={() => {
              /* Article routing lands with the content service. */
            }}
          />
        ))}

        <ListRow
          standalone
          icon="email"
          title={t('Contact Support')}
          subtitle={t('Email our support team')}
          testID="help-contact"
          onPress={() => void Linking.openURL(`mailto:${SUPPORT_EMAIL}`)}
        />
      </View>
    </ScreenShell>
  );
}

const styles = StyleSheet.create({
  subtitle: {
    marginTop: space.xs,
    marginBottom: space.lg,
  },
  list: {
    gap: space.md,
  },
});
